var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { PHASE, Phases } from "../routeConfig";
import { CLOSE_REASONS } from "../lib/constants";
import { CloseButtonSVG } from "./Icons/Icons";
import Image from "./Image";
import classNames from "classnames";
import isValidAppRoute from "../utils/isValidAppRoute";
import { isValidPathname } from "../utils/typeUtils";
import useAppSelector from "../hooks/useAppSelector";
import useCloseClickHandler from "../hooks/useCloseClickHandler";
import useHandleBackClick from "../hooks/useHandleBackClick";
import useMemoryHistory from "../hooks/useMemoryHistory";
import useRouteConfig from "../hooks/useRouteConfig";
function Button(_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("button", __assign({ className: classNames("t-0 m-3 inline-flex h-6 w-6 grow-0 border-none bg-transparent p-0 focus:outline-none", className) }, rest)));
}
export default function Header(_a) {
    var onClose = _a.onClose, children = _a.children, _b = _a.disableBack, disableBackProp = _b === void 0 ? false : _b, disableClose = _a.disableClose, goBackOverride = _a.goBackOverride, _c = _a.showDropShadow, showDropShadow = _c === void 0 ? false : _c;
    var handleCloseClick = useCloseClickHandler();
    var entries = useMemoryHistory().entries;
    var index = useAppSelector(function (state) { return state.navigation.index; });
    var handleBack = useHandleBackClick(goBackOverride);
    var routeConfig = useRouteConfig();
    var isEditingRemarketingPolicy = useAppSelector(function (state) { return state.applicant.isEditingRemarketingPolicy; });
    var prevHistoryEntry = index !== -1 ? entries[index - 1] : null;
    var previousConfig = prevHistoryEntry && isValidPathname(prevHistoryEntry.pathname)
        ? Phases[prevHistoryEntry.pathname]
        : undefined;
    var shouldPreventBackToOfferList = isEditingRemarketingPolicy &&
        (prevHistoryEntry === null || prevHistoryEntry === void 0 ? void 0 : prevHistoryEntry.pathname) === PHASE.AUTO_OFFER_LIST;
    // we do not persist our route changes currently, either via localstorage or browser APIs. The check below looks to make sure we
    // are not trying to back into the '/' route, which is the initial entry before our first phase. On a refresh, this will prevent
    // a user from clicking back from their current phase, which currenly throws an error
    var SHOULD_SHOW_BACK_NAVIGATION = prevHistoryEntry &&
        isValidAppRoute(prevHistoryEntry.pathname) &&
        !(previousConfig === null || previousConfig === void 0 ? void 0 : previousConfig.disableNextRouteBackNavigation) &&
        !(routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.disableBackButton) &&
        !shouldPreventBackToOfferList &&
        !disableBackProp;
    var SHOULD_SHOW_CLOSE_BUTTON = !disableClose && (routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.closable);
    function handleClose() {
        handleCloseClick({
            reason: CLOSE_REASONS.CLICKED_CLOSE_BUTTON,
        });
        if (onClose) {
            onClose();
        }
    }
    var renderQAHeader = function () {
        var env = process.env.NODE_ENV;
        if (env === "production") {
            return null;
        }
        var buildTime = env === "development"
            ? new Date().toLocaleString()
            : process.env.BUILD_TIME;
        var commitHash = env === "development" ? "" : process.env.BUILD_HASH;
        return (React.createElement("div", { className: "m-2 text-xs italic" },
            env,
            " - ",
            commitHash,
            " ",
            buildTime));
    };
    return (React.createElement("div", { id: "header", className: classNames("align-end relative top-0 z-50 flex h-14 w-full flex-none items-center", { "shadow-header": showDropShadow }) },
        SHOULD_SHOW_BACK_NAVIGATION ? (React.createElement(Button, { className: "absolute left-0 items-center justify-center", onClick: handleBack, id: "back" },
            React.createElement(Image, { src: "/assets/icons/back.svg", alt: "" }))) : null,
        React.createElement("div", { className: classNames("flex h-full grow items-center justify-center px-4", {
                "ml-9 mr-9": SHOULD_SHOW_BACK_NAVIGATION,
            }) }, children || renderQAHeader()),
        SHOULD_SHOW_CLOSE_BUTTON ? (React.createElement(Button, { className: "absolute right-0 items-center justify-center", onClick: handleClose, id: "close" },
            React.createElement(CloseButtonSVG, null))) : null));
}
